import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RelativityDatasourceService {
  datasource = signal<string | null>(null);

  setDatasource(ds: string | null) {
    this.datasource.set(ds);
  }
}
